import { useTranslation } from 'react-i18next'
import { PDFViewer } from '@/components/PDFViewer/PDFViewer'
import { type ProductOfferFragment } from '@/services/graphql/generated'
import { useIsEmbedded } from '@/utils/useIsEmbedded'
import { SupText } from 'ui/src/components/SupText/SupText'
import { Text } from 'ui/src/components/Text/Text'

type Props = {
  documents: ProductOfferFragment['variant']['documents']
}

export function ProductDocuments({ documents }: Props) {
  const { t } = useTranslation('cart')

  const isEmbedded = useIsEmbedded()

  const productDocuments = documents.map((item) => ({
    title: item.displayName,
    url: item.url,
  }))

  if (productDocuments.length === 0) {
    return null
  }

  return (
    <div>
      <Text size={{ _: 'sm', sm: 'md' }}>{t('DOCUMENTS_SECTION_LABEL')}</Text>
      <ul>
        {productDocuments.map(({ title, url }) => (
          <li key={title}>
            {isEmbedded ? (
              <PDFViewer url={url}>
                <button>
                  <Text size={{ _: 'sm', sm: 'md' }} as="span" color="textTranslucentSecondary">
                    {title}
                    <SupText>PDF</SupText>
                  </Text>
                </button>
              </PDFViewer>
            ) : (
              <a href={url} target="_blank" rel="noopener noreferrer">
                <Text size={{ _: 'sm', sm: 'md' }} as="span" color="textTranslucentSecondary">
                  {title}
                  <SupText>PDF</SupText>
                </Text>
              </a>
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}
